import { useEffect, useRef, useState } from "react";

/**
 * Animates a number from its previous value to the new one (data-driven,
 * not hover-triggered). Respects prefers-reduced-motion.
 */
export default function useCountUp(value, ms = 400) {
  const [display, setDisplay] = useState(value);
  const from = useRef(value);
  const frame = useRef(null);

  useEffect(() => {
    const start = from.current;
    const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduce || start === value || !Number.isFinite(start) || !Number.isFinite(value)) {
      from.current = value;
      setDisplay(value);
      return undefined;
    }
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / ms);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = start + (value - start) * eased;
      from.current = v;
      setDisplay(v);
      if (p < 1) frame.current = requestAnimationFrame(tick);
    };
    frame.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame.current);
  }, [value, ms]);

  return display;
}
